import { dataSortAlt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSortAlt = /*#__PURE__*/createIcon(dataSortAlt)
export default IconSortAlt
